var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basket_Icon",
    "data-name": "Basket Icon",
    transform: "translate(-48 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 32,
    height: 32,
    transform: "translate(48 216)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-shopping-basket",
    "data-name": "Icon material-shopping-basket",
    d: "M19.184,10.645,14.405,3.488A1.083,1.083,0,0,0,13.5,3.03a1.066,1.066,0,0,0-.905.469L7.816,10.645H2.591A1.094,1.094,0,0,0,1.5,11.735a.919.919,0,0,0,.044.295L4.315,22.143a2.17,2.17,0,0,0,2.095,1.593H20.591A2.192,2.192,0,0,0,22.7,22.143L25.467,12.03l.033-.295a1.094,1.094,0,0,0-1.091-1.091Zm-8.956,0,3.273-4.8,3.273,4.8ZM13.5,19.372a2.182,2.182,0,1,1,2.182-2.182A2.188,2.188,0,0,1,13.5,19.372Z",
    transform: "translate(50.5 219.018)",
    fill: "#2666cf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket-icon.cd26f4140f70b6e528e05c10575fddbe.svg";
export { ForwardRef as ReactComponent };